export const PostSubmitErrorsMap = {
    'The publication limit has been exceeded':
        'Превышен лимит публикаций, попробуйте вернуться позже.',
    'Clickouts must not contain utm_source.': 'Ссылки не должны содержать utm_source.',
    'Clickouts must lead to your website, marketplace or messenger.':
        'Ссылки должны вести на ваш сайт, маркетплейс или мессенджер.',
    'The text of the post cannot be empty.': 'Описание поста должно быть заполнено.',
    'Blogger posts must include at least one product': 'Пост должен содержать ссылку на товар',
};
